// extracted by mini-css-extract-plugin
export default {"menuBlock":"IE-z","title":"JE-z","nav":"KE-z","flexCell":"LE-z","facetLink":"ME-z"};